import setGadjet from './../../../image/set/setGajet.webp'
import origami from './../../../image/set/origami.webp'
import sushiHaus from './../../../image/set/sushiHaus.webp'
import setNaRadost from './../../../image/set/setNaRadost.webp'
import setNaZavist from './../../../image/set/setNaZavist.webp'
import naDvoih from './../../../image/set/NaDvoih.webp'
import prazdnichnii from './../../../image/set/Prazdnichnii.webp'
import semeinii from './../../../image/set/semeinii.webp'

export const imagesSets = {
    setGadjet:setGadjet,
    origami:origami,
    sushiHaus:sushiHaus,
    setNaRadost:setNaRadost,
    setNaZavist:setNaZavist,
    naDvoih:naDvoih,
    prazdnichnii:prazdnichnii,
    semeinii:semeinii


}